module.exports = __webpack_public_path__ + "static/media/302.6303f625.svg";